import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgBusyModule} from 'ng-busy';
import {StorageService} from './services/storage.service';
import {MomentModule} from 'ngx-moment';
import {NgSelect2Component} from './components/ng-select2/ng-select2.component';
import {NgDropdownCustomComponent} from './components/ng-dropdown-custom/ng-dropdown-custom.component';
import {WidgetChartComponent} from './components/widget-chart/widget-chart.component';
import { NgCheckboxComponent } from './components/ng-checkbox/ng-checkbox.component';
import { NgDatepickerComponent } from './components/ng-datepicker/ng-datepicker.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { NgFileComponent } from './components/ng-file/ng-file.component';


export function httpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgBusyModule,
        MomentModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient]
            }
        }),
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgBusyModule,
        MomentModule,
        NgSelect2Component,
        NgDropdownCustomComponent,
        WidgetChartComponent,
        NgCheckboxComponent,
        NgDatepickerComponent,
        TranslateModule,
        UploadFileComponent,
        NgFileComponent

    ],
    declarations: [
        NgSelect2Component,
        NgDropdownCustomComponent,
        WidgetChartComponent,
        NgCheckboxComponent,
        NgDatepickerComponent,
        UploadFileComponent,
        NgFileComponent,

    ],
    providers: [StorageService]
})
export class SharedModule {

}
